"use client";

import { c as _c } from "react/compiler-runtime";
import { IconX } from "@tabler/icons-react";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { recoverVerification } from "@/lib/recoverVerification";
import { clearBannerDismissed, clearVerifyEmailBanner, isBannerDismissed, isVerified, setBannerDismissed, shouldShowBanner, VERIFY_EMAIL_BANNER_EVENT } from "@/lib/verifyEmailBanner";
import { useAuthClaimsStore } from "@/stores/useAuthClaimsStore";
import { useServicesStore } from "@/stores/useServicesStore";
export function VerifyEmailBanner() {
  const $ = _c(8);
  const [showBanner, setShowBanner] = useState(false);
  const claims = useAuthClaimsStore(_temp);
  const authResolved = useServicesStore(_temp2);
  const router = useRouter();
  const wasShowingRef = useRef(false);
  let t0;
  let t1;
  if ($[0] !== authResolved || $[1] !== claims || $[2] !== router) {
    t0 = () => {
      const onReturnFromAuth0 = _temp3;
      const handleVerified = () => {
        const justVerified = wasShowingRef.current;
        wasShowingRef.current = false;
        clearBannerDismissed();
        clearVerifyEmailBanner();
        setShowBanner(false);
        if (justVerified) {
          router.refresh();
        }
      };
      const updateFromStorage = () => {
        const show = shouldShowBanner(onReturnFromAuth0);
        wasShowingRef.current = show;
        setShowBanner(show);
      };
      const refreshBanner = () => {
        if (authResolved && isVerified(claims)) {
          handleVerified();
          return;
        }
        if (authResolved && claims && !isBannerDismissed()) {
          wasShowingRef.current = true;
          setShowBanner(true);
          return;
        }
        updateFromStorage();
      };
      refreshBanner();
      window.addEventListener(VERIFY_EMAIL_BANNER_EVENT, refreshBanner);
      return () => window.removeEventListener(VERIFY_EMAIL_BANNER_EVENT, refreshBanner);
    };
    t1 = [authResolved, claims, router];
    $[0] = authResolved;
    $[1] = claims;
    $[2] = router;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      wasShowingRef.current = false;
      setBannerDismissed();
      clearVerifyEmailBanner();
      setShowBanner(false);
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const dismissBanner = t2;
  if (!showBanner) {
    return null;
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="flex w-full flex-col items-center justify-center text-center md:flex-row">We sent a verification link to your email. Please verify your email for full account access.{" "}<a href="/account/verify/" className="ml-2 mt-2 rounded border border-white px-1.5 py-0.75 text-sm font-normal text-white no-underline md:mt-0">Send another email</a></p>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="relative bg-[#3A6682] px-10 py-3 text-white md:px-5">{t3}<button type="button" className="absolute right-5 top-3.5" onClick={dismissBanner} aria-label="Dismiss verify email banner"><IconX className="h-4 w-4" /></button></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp3() {
  return void recoverVerification(window.location.pathname);
}
function _temp2(state_0) {
  return state_0.authResolved;
}
function _temp(state) {
  return state.claims;
}